const PairingImage = ({ ingredients, style }) => {
  const maxImgPerStyle = {
    customization: 4,
    'order-details': 6,
    rdp: 6,
  };

  const ingredientsCount = ingredients.length;
  const imgsNum =
    ingredientsCount > maxImgPerStyle[style]
      ? maxImgPerStyle[style]
      : ingredientsCount;
  const className = `pairing-img-component ${style}-${imgsNum}`;
  ingredients = ingredients.slice(0, imgsNum);
  return (
    <div className={className}>
      {ingredients.map((p) => {
        return (
          <div
            key={p.id}
            className={'pairing-img'}
            style={{ backgroundImage: `url("${p['card_image_url']}")` }}
          ></div>
        );
      })}
    </div>
  );
};

export default PairingImage;
